import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAll = async (params) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions`,
      params,
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getById = async (actionId) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/action/${actionId}`,
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const editAction = async ({
  actionId,
  requesterId,
  responsible1,
  responsible2,
  focalPoint,
  actionDescription,
  actionNumber,
  deadline,
  status,
  chairpersonValidation
}) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/${actionId}`,
      {
        requesterId,
        responsible1,
        focalPoint,
        responsible2,
        actionDescription,
        actionNumber,
        deadline,
        ...(status && { status }),
        chairpersonValidation
      }
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = response.data.errors.length > 0 ? response.data.errors.join(', ') : " ";

    return responseFormat;
  }
};

export const sendActionMail = async ({
  content,
  recipients,
  minuteActionId,
  attachments,
}) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/sendEmail`,
      {
        content,
        recipients,
        minuteActionId,
        attachments,
      },
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const bulkUpdateFocalPoint = async ({ focalPointId, actionIds }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/actions/focalPoint`,
      {
        ActionIds: actionIds,
        FocalPointId: focalPointId,
      }
    );
    return { error: "", data };
  } catch ({ response }) {
    const errorMessage = response?.data?.errors?.length > 0
      ? response.data.errors.join(', ')
      : "async";
    return { error: errorMessage, data: null };
  }
};
